<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">任务中心</div>
        <div class="view-mode-bar" style="padding: 0 0 10px 0;">
          <el-radio-group v-model="viewMode" size="small" @change="onViewModeChange">
            <el-radio-button label="list">列表</el-radio-button>
            <el-radio-button label="stat">统计</el-radio-button>
          </el-radio-group>
        </div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="接收人">
            <el-select v-model="receiveUserId" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.name"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务状态">
            <el-select v-model="taskStatus" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in dict.type.integrated_task_status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务标题" prop="">
            <el-input v-model="searchValue" placeholder="请输入任务标题"></el-input>
          </el-form-item>
          <el-form-item label="下发时间" prop="dateRange">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              :clearable="false"
              unlink-panels
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar" v-if="viewMode === 'list'">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <!-- 列表视图 -->
          <div v-if="viewMode === 'list'" class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="receiveUser" label="接收人"></el-table-column>
              <el-table-column prop="title" label="任务标题"></el-table-column>
              <el-table-column prop="address" label="任务地址"></el-table-column>
              <el-table-column prop="addressExtra" label="补充任务地址"></el-table-column>
              <el-table-column prop="createTime" label="下发时间"></el-table-column>
              <el-table-column prop="endTime" label="截止时间"></el-table-column>
              <el-table-column prop="statusTranslated" label="状态"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看详情</el-button
                    >
                    <el-button
                      @click="suspenseTask(scope.row)"
                      type="text"
                      size="small"
                      >督促</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 统计视图 -->
          <div v-else class="zj-table-container">
            <el-table
              v-loading="statLoading"
              element-loading-text="加载中..."
              :data="statData"
              border
              style="width: 100%"
              show-summary
              :summary-method="statSummary"
              @cell-click="onCellClick"
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="receiveUser" label="接收人" show-overflow-tooltip></el-table-column>
              <el-table-column prop="total" label="总数" width="90" align="center"></el-table-column>
              <el-table-column
                prop="finished"
                label="已完成/完成率"
                align="center"
                :formatter="formatStat"
                class-name="stat-finished"
              ></el-table-column>
              <el-table-column
                prop="processing"
                label="处理中/处理中率"
                align="center"
                :formatter="formatStat"
                class-name="stat-processing"
              ></el-table-column>
              <el-table-column
                prop="overdue"
                label="已逾期/已逾期率"
                align="center"
                :formatter="formatStat"
                class-name="stat-overdue"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="110"
                align="center"
                :formatter="formatAction"
                class-name="stat-action"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer v-if="viewMode === 'list'">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { urbanUserList, taskList, listAllTask, taskSupervise } from "@/api/src/urbanServerApi";

// 缺省下发时间范围：最近一个月
const defaultRange = () => [
  new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
  new Date(),
];

export default {
  name: "TaskCenterList",
  controller: "UI",
  action: "TaskCenterList",
  dicts: ["integrated_task_status"],
  data() {
    return {
      viewMode: "list",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      statData: [],
      statLoading: false,
      userList: [],
      receiveUserId: "",
      taskStatus: "",
      searchValue: "",
      dateRange: defaultRange(),
    };
  },
  mounted: function () {
    this.searchUserList();
    this.restoreState();
    if (this.viewMode === "stat") {
      this.loadStat();
    } else {
      this.search();
    }
  },
  methods: {
    searchUserList() {
      let that = this;
      urbanUserList().then((res) => {
        if (res.code == 200) {
          that.userList = res.data || [];
        }
      });
    },
    // 下发时间范围 -> begin/end（yyyy-MM-dd）
    getTimeRange() {
      let begin = null;
      let end = null;
      if (this.dateRange && this.dateRange.length === 2) {
        begin = this.dateRange[0].format("yyyy-MM-dd");
        end = this.dateRange[1].format("yyyy-MM-dd");
      }
      return { begin, end };
    },
    // 下发时间必填校验
    checkDate() {
      if (
        !this.dateRange ||
        this.dateRange.length !== 2 ||
        !this.dateRange[0] ||
        !this.dateRange[1]
      ) {
        this.$message.warning("请选择下发时间");
        return false;
      }
      return true;
    },
    search() {
      const { begin, end } = this.getTimeRange();
      let searchInfo = {
        receiveUserId: this.receiveUserId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        status: this.taskStatus,
        search: this.searchValue,
        begin: begin || undefined,
        end: end || undefined,
      };
      taskList(searchInfo).then((res) => {
        if (res.code == 200) {
          this.tableData = res.rows;
          this.total = res.total;
        }
      });
    },
    // 统计视图：拉取当前筛选下的全部任务，前端按接收人聚合
    loadStat() {
      this.statLoading = true;
      const { begin, end } = this.getTimeRange();
      const query = {
        receiveUserId: this.receiveUserId,
        status: this.taskStatus,
        search: this.searchValue,
        begin: begin || undefined,
        end: end || undefined,
      };
      listAllTask(query)
        .then(({ rows }) => {
          this.statLoading = false;
          this.statData = this.aggregateByReceiver(rows || []);
        })
        .catch((e) => {
          console.log(e);
          this.statLoading = false;
          this.$message.error("统计加载失败");
        });
    },
    aggregateByReceiver(rows) {
      const statusKeyMap = {
        已完成: "finished",
        处理中: "processing",
        已逾期: "overdue",
      };
      const map = {};
      rows.forEach((r) => {
        const name = r.receiveUser || "(未指定)";
        if (!map[name]) {
          map[name] = {
            receiveUser: name,
            total: 0,
            finished: 0,
            processing: 0,
            overdue: 0,
            other: 0,
          };
        }
        map[name].total++;
        const k = statusKeyMap[r.statusTranslated] || "other";
        map[name][k]++;
      });
      return Object.values(map);
    },
    rate(count, total) {
      if (!total) return "0.0%";
      return ((count / total) * 100).toFixed(1) + "%";
    },
    formatStat(row, column) {
      const cnt = row[column.property] || 0;
      return cnt + " / " + this.rate(cnt, row.total);
    },
    // 操作列文字（show-summary 表格 slot-scope 不渲染，改用 formatter + cell-click）
    formatAction() {
      return "查看详情";
    },
    onCellClick(row, column) {
      if (column.label === "操作") {
        this.onStatDetail(row);
      }
    },
    // 跳转接收人任务详情前保存列表页状态，供返回时恢复
    saveState() {
      const s = {
        viewMode: this.viewMode,
        dateRange:
          this.dateRange && this.dateRange.length === 2
            ? [this.dateRange[0].getTime(), this.dateRange[1].getTime()]
            : null,
        receiveUserId: this.receiveUserId,
        taskStatus: this.taskStatus,
        searchValue: this.searchValue,
        currentPage: this.currentPage,
      };
      try {
        sessionStorage.setItem("taskCenterStatState", JSON.stringify(s));
      } catch (e) {
        console.log(e);
      }
    },
    restoreState() {
      try {
        const raw = sessionStorage.getItem("taskCenterStatState");
        if (!raw) return;
        const s = JSON.parse(raw);
        this.viewMode = s.viewMode || "list";
        if (s.dateRange && s.dateRange.length === 2) {
          this.dateRange = [new Date(s.dateRange[0]), new Date(s.dateRange[1])];
        }
        this.receiveUserId = s.receiveUserId || "";
        this.taskStatus = s.taskStatus || "";
        this.searchValue = s.searchValue || "";
        this.currentPage = s.currentPage || 1;
        sessionStorage.removeItem("taskCenterStatState");
      } catch (e) {
        console.log(e);
      }
    },
    // 跳转接收人任务详情
    onStatDetail(row) {
      this.saveState();
      const { begin, end } = this.getTimeRange();
      this.$router.push({
        path: "/plugin/TaskCenter/UI/TaskCenterStatDetail",
        query: {
          receiveUser: row.receiveUser,
          begin: begin || "",
          end: end || "",
        },
      });
    },
    statSummary({ columns, data }) {
      const sums = [];
      const keyMap = {
        "已完成/完成率": "finished",
        "处理中/处理中率": "processing",
        "已逾期/已逾期率": "overdue",
      };
      columns.forEach((col, idx) => {
        if (idx === 0) {
          sums[idx] = "合计";
          return;
        }
        if (col.label === "接收人") {
          sums[idx] = "共 " + data.length + " 人";
          return;
        }
        if (col.label === "总数") {
          sums[idx] = data.reduce((s, r) => s + r.total, 0);
          return;
        }
        const key = keyMap[col.label];
        if (key) {
          const cnt = data.reduce((s, r) => s + r[key], 0);
          const tot = data.reduce((s, r) => s + r.total, 0);
          sums[idx] = cnt + " / " + this.rate(cnt, tot);
          return;
        }
        sums[idx] = "";
      });
      return sums;
    },
    onViewModeChange() {
      if (!this.checkDate()) {
        this.viewMode = this.viewMode === "stat" ? "list" : "stat";
        return;
      }
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/TaskCenter/UI/TaskCenterDetails",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/TaskCenter/ui/TaskCenterDetails",
        query: { id: row.id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/TaskCenter/ui/TaskCenterDetails",
        query: { id: row.id, type: "edit" },
      });
    },
    //督办
    suspenseTask(row) {
      taskSupervise({ id: row.id }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.$message({
            type: "success",
            message: "督促成功!",
          });
        }
      });
    },
    // 点击查询按钮
    onSearch() {
      if (!this.checkDate()) return;
      this.currentPage = 1;
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    clearsearch() {
      this.receiveUserId = "";
      this.taskStatus = "";
      this.searchValue = "";
      this.dateRange = defaultRange();
    },
    // 点击清理按钮
    onCancel() {
      this.clearsearch();
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style>
.stat-finished .cell { color: #67C23A; }
.stat-processing .cell { color: #409EFF; }
.stat-overdue .cell { color: #F56C6C; }
.stat-action .cell { color: #409EFF; cursor: pointer; }
.stat-action .cell:hover { text-decoration: underline; }
</style>
